import clsx from 'clsx'
import { useMemo } from 'react'

import styles from './workspace-body.module.scss'
import { ObjectItem } from '../../../../../entities/objects/types/object.types'
import { Checklist, MilestoneItem } from '../../../../../entities/workflow/types/workflow.types'
import { WorkspaceControls } from '../workspace-controls/workspace-controls'
import { WorkspaceTable } from '../workspace-table/workspace-table'

type WorkspaceBodyProps = {
  objects: ObjectItem[]
  milestones?: MilestoneItem[]
  checklists?: Checklist[]
}

export const WorkspaceBody = ({ objects, milestones, checklists = [] }: WorkspaceBodyProps) => {
  const sortedMilestones = useMemo(() => {
    if (!milestones) {
      return []
    }

    return [...milestones].sort((a, b) => a.seq - b.seq)
  }, [milestones])

  return (
    <div className={clsx(styles.workspaceBodyWrap)}>
      <WorkspaceControls milestones={sortedMilestones} />
      <div className={clsx(styles.workspaceTableWrap, 'pt-4')}>
        <WorkspaceTable
          checklists={checklists}
          milestones={sortedMilestones}
          objects={objects}
        />
      </div>
    </div>
  )
}
